import React, { useEffect, useState } from 'react';
import { Table, Form, Button, Spinner, Alert } from 'react-bootstrap';
import useAffiliations from 'hooks/userManagement/useAffiliations';
import { toast } from 'react-toastify';

const ViewAffiliationForm = ({ id }) => {


  const { getAffiliationByCode, loading, error, getAffiliationById} = useAffiliations();
  const [newTypeName, setNewTypeName] = useState('');
  const [category, setCategory] = useState('SOCIAL');
  const [note, setNote] = useState('');
  // const [isSubmitting, setIsSubmitting] = useState(false);
  // const [localError, setLocalError] = useState(null);

  useEffect(() => {

  getAffiliationById(id).then((data) => {
    setNewTypeName(data.displayName);
    setCategory(data.category);
    setNote(data.description);
  }).catch((err) => {
    console.error('Failed to fetch affiliation data', err);
  });
}, [id, getAffiliationById]);

  const handleSubmit = async (e) => {
  // e.preventDefault();
  // setLocalError(null);

  //   try {
  //     setIsSubmitting(true);

  //     if (!newTypeName.trim()) {
  //       setLocalError('Enter affiliation name');
  //       return;
  //     }

  //     const code = newTypeName.trim().toUpperCase().replace(/\s+/g, '_');

  //     // PRE-CHECK: ensure code isn't already present
  //     try {
  //       await getAffiliationByCode(code);
  //       setLocalError(`Affiliation "${code}" already exists`);
  //       return;
  //     } catch (err) {
  //       // expected -> not found
  //     }

  //     await updateAffiliation(id, {
  //       code,
  //       displayName: newTypeName.trim(),
  //       description: note?.trim() || '',
  //       category: category,
  //       active: true
  //     });

  //     toast.success('Affiliation modified');

  //   //   setNewTypeName('');
  //   //   setNote('');
  //   //   setCategory('SOCIAL');
  //   //   onAdded && onAdded();
  //   } catch (err) {
  //     const errorMsg = err.message || 'Failed to modify affiliation';
  //     setLocalError(errorMsg);
  //     toast.error(errorMsg);
  //   } finally {
  //     setIsSubmitting(false);
  //   }
};


  return (
    <Form onSubmit={handleSubmit}>
      {/* {(localError || error) && (
        <Alert variant="danger" className="mb-3">
          {localError || error}
        </Alert>
      )} */}

      <Table borderless className="fs-10 mb-3">
        <tbody>
          <tr>
            <td className="py-2 fw-bold text-nowrap" style={{ width: '140px' }}>
              <Form.Label className="mb-0">Affiliation Name</Form.Label>
            </td>
            <td className="py-2">
              <Form.Control
                type="text"
                placeholder="Name for affiliation"
                value={newTypeName}
                onChange={(e) => setNewTypeName(e.target.value)}
                disabled={true}
                className="fs-10"
              />
            </td>
          </tr>

          <tr>
            <td className="py-2 fw-bold text-nowrap">
              <Form.Label className="mb-0">Category</Form.Label>
            </td>
            <td className="py-2">
              <Form.Select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                disabled={true}
                className="fs-10"
              >
                <option value="SOCIAL">Social</option>
                <option value="ECONOMIC">Economic</option>
                <option value="SERVICE">Service</option>
              </Form.Select>
            </td>
          </tr>

          <tr>
            <td className="py-2 fw-bold text-nowrap">
              <Form.Label className="mb-0">Notes</Form.Label>
            </td>
            <td className="py-2">
              <Form.Control
                as="textarea"
                placeholder="Optional notes about this affiliation"
                value={note}
                onChange={(e) => setNote(e.target.value)}
                disabled={true}
                rows={2}
                className="fs-10"
              />
            </td>
          </tr>
        </tbody>
      </Table>

      {/* <div className="d-flex gap-2 justify-content-end mt-3">
        <Button
          variant="success"
          type="submit"
          disabled={loading || isSubmitting}
          className="fs-10"
        >
          {isSubmitting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Saving...
            </>
          ) : (
            'Confirm'
          )}
        </Button>
      </div> */}
    </Form>
  );
};

export default ViewAffiliationForm;
